import { render, staticRenderFns } from "./add_member.vue?vue&type=template&id=0c5859d2&scoped=true&"
import script from "./add_member.vue?vue&type=script&lang=js&"
export * from "./add_member.vue?vue&type=script&lang=js&"
import style0 from "./add_member.vue?vue&type=style&index=0&id=0c5859d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5859d2",
  null
  
)

export default component.exports